/**
 * Toggle login / registro en Mi cuenta (misma página, un panel a la vez).
 */
export function initAccountAuthToggle() {
  const root = document.getElementById('customer_login');
  if (!root) {
    return;
  }

  root.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-account-panel]');
    if (!trigger || !root.contains(trigger)) {
      return;
    }

    event.preventDefault();
    const panel = trigger.getAttribute('data-account-panel');
    root.classList.toggle('is-register', panel === 'register');
  });
}
